module.exports = __webpack_public_path__ + "img/삼성역 고기집.81c6c405.png";